import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { ChatContainerView } from "MessagingV2/routes";
export default store => ({
  path: "messaging/settings/chat-view/:userId/chats",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "messaging-settings" */ "./components"),
        import(
          /* webpackChunkName: "messaging-settings" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducerImport = importedModule1;
        injectReducer(store, {
          key: reducerImport.NAME,
          reducer: reducerImport.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ChatContainerView(store)], // this dynamic route should be at bottom
});
